// extracted by mini-css-extract-plugin
export var aircallIframe = "_jn-3";
export var fabContainer = "_jn-5";
export var fabRinging = "_jn-6";
export var loadingOverlay = "_jn-4";
export var pulse = "_jn-7";
export var widgetContent = "_jn-2";
export var widgetPanel = "_jn-0";
export var widgetPanelExpanded = "_jn-1";